import React from "react";
import {
  Clock, Search, CheckCircle2, XCircle, Banknote, BadgeCheck, Hourglass, FileQuestion,
} from "lucide-react";

const MAP = {
  UNDER_REVIEW: { label: "Under Review", cls: "bg-sky-50 text-sky-700 border-sky-200", Icon: Search },
  INFO_REQUESTED: { label: "Info Requested", cls: "bg-amber-50 text-amber-700 border-amber-200", Icon: FileQuestion },
  APPROVED: { label: "Offer Ready", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", Icon: BadgeCheck },
  REJECTED: { label: "Rejected", cls: "bg-rose-50 text-rose-700 border-rose-200", Icon: XCircle },
  DISBURSE_PENDING: { label: "Disbursement Processing", cls: "bg-indigo-50 text-indigo-700 border-indigo-200", Icon: Hourglass },
  DISBURSED: { label: "Disbursed", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", Icon: Banknote },
  REPAID: { label: "Repaid / Completed", cls: "bg-blue-50 text-blue-700 border-blue-200", Icon: CheckCircle2 },
  pending: { label: "Verification Pending", cls: "bg-amber-50 text-amber-700 border-amber-200", Icon: Clock },
  confirmed: { label: "Confirmed", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", Icon: CheckCircle2 },
  rejected: { label: "Rejected", cls: "bg-rose-50 text-rose-700 border-rose-200", Icon: XCircle },
  info_requested: { label: "Info Requested", cls: "bg-amber-50 text-amber-700 border-amber-200", Icon: FileQuestion },
  active: { label: "Active Offer", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", Icon: BadgeCheck },
  accepted: { label: "Accepted", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", Icon: BadgeCheck },
  disbursed: { label: "Disbursed", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", Icon: Banknote },
  repaid: { label: "Repaid", cls: "bg-blue-50 text-blue-700 border-blue-200", Icon: CheckCircle2 },
  cancelled: { label: "Cancelled", cls: "bg-slate-100 text-slate-600 border-slate-200", Icon: XCircle },
  CANCELLED: { label: "Cancelled", cls: "bg-slate-100 text-slate-600 border-slate-200", Icon: XCircle },
};

export const StatusBadge = ({ status, className = "" }) => {
  const cfg = MAP[status] || { label: status || "-", cls: "bg-slate-100 text-slate-600 border-slate-200", Icon: Clock };
  const { Icon } = cfg;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold ${cfg.cls} ${className}`}
    >
      <Icon className="h-3.5 w-3.5" />
      {cfg.label}
    </span>
  );
};
